import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Helmet from 'react-helmet';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {SessionRequired} from '../../../lib/api/components/SessionRequired';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Route, Switch} from "react-router-dom";
import {Dashboard} from "./Dashboard";

@injectIntl
export class Certificate extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    }

    render() {
        const { dispatch, session } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.my_certificate' })} />
                <Page.Header />
                <SessionRequired dispatch={dispatch} session={session}>
                    <Switch>
                        <Route exact path='/certificate' component={Dashboard} />
                    </Switch>
                </SessionRequired>
                <Page.Footer />
            </Page>
        );
    }
}

export default connect(state => ({
    session: state.session,
    dispatch: state.dispatch,
}))(Certificate);
